import type {
  FeedbackGroup,
  FeedbackGroupState,
  FeedbackType,
  GetFeedbackGroupResultType,
} from '../types/FeedbackGroup.types';

export type GetFeedbackGroupResultParams = {
  feedbackGroups: FeedbackGroup[];
  lineItemId: string;
  requestType: FeedbackType;
  groupState: FeedbackGroupState;
};

/**
 * This is a helper function to get feedback group result for the given line item.
 *
 * @returns A feedback group result associated with the given line item.
 */
export const getFeedbackGroupResult = (
  props: GetFeedbackGroupResultParams
): GetFeedbackGroupResultType => {
  const { feedbackGroups, lineItemId, requestType, groupState } = props;

  if (!lineItemId) {
    return {
      customerFeedbackGroup: undefined,
      customerFeedbackGroupExists: false,
    };
  }

  /**
   * Returns the customer feedback group that meets all of the criteria.
   * If none are found, returns an empty object.
   */
  const customerFeedbackGroup = feedbackGroups.filter(
    (feedbackGroup) =>
      feedbackGroup.lineItemIds.includes(lineItemId) &&
      feedbackGroup.type === requestType &&
      feedbackGroup.state === groupState
  )[0];

  if (!customerFeedbackGroup) {
    return {
      customerFeedbackGroup: undefined,
      customerFeedbackGroupExists: false,
    };
  }

  return {
    customerFeedbackGroup,
    customerFeedbackGroupExists: true,
  };
};
